<template>
    <loading v-if="pageLoading"/>
    <OrderMode @selectMode="selectMode" v-else-if="!pageLoading && !isBuffet"/>
    <div v-else :class="{
        'delivery-container': true, 'delivery-list-page-container': true, 'delivery-list-store-page-container': pageFrom === 'store'
    }">
        <div class="hidePage" v-if="hidePage"></div>
        <!-- begin banner -->
        <div
            class="banner"
            v-if="pageFrom != 'store' && !isTheme1"
            :style="
        `${(!bannerList || !bannerList.length)? 'background: url( '+storeInfo && storeInfo.background && storeInfo.background.url+');background-size: cover;background-position: center center'
           : ''
        }`"
        >
            <swiper
                ref="mySwiper"
                :options="swiperOptions"
                v-if="bannerList.length != 0"
            >
                <swiper-slide
                    v-show="bannerList.length > 0"
                    v-for="(item, index) in bannerList"
                    :key="index"
                >
                    <img
                        :src="item.backg_imgs"
                        @click.stop.prevent="handleBannerClick(item)"
                        class="banner-item"
                    />
                </swiper-slide>
                <div
                    class="swiper-pagination swiper-pagination-white"
                    slot="pagination"
                    v-show="bannerList.length > 1"
                ></div>
            </swiper>
        </div>
        <!-- end banner -->

        <!-- 商品搜索框-->
        <div class="search-input" v-if="pageFrom === 'store'">
            <input type="text" v-model="searchKeywords" placeholder="请输入商品名、编号" />
            <v-icon color="#ddd">search</v-icon>
        </div>

        <!-- begin loading -->
        <div v-if="pageLoading" class="page-loading-container">
            <v-progress-circular
                :size="60"
                :width="5"
                color="primary"
                indeterminate
            ></v-progress-circular>
        </div>
        <!-- end loading -->

        <!-- dark theme menu nav-->
        <div class="sidebar-nav-theme1" v-if="isTheme1">
            <div
                class="sidebar-nav__item side-list-hook"
                v-for="(item, index) in categoryList"
                :key="item.guid"
                :id="`sidebar-${index}`"
                :class="{ active: index === (getIsDacateShow ? activeCategoryIndex : activeCategory) }"
                v-show="item.commodites && item.commodites.length"
                @click="goAnchor($event, `#category-${index}`, index)"
            >
              {{
                item.guid === 'recommended' ?
                    (item.category_name_json[language] || item.name)
                    :
                    (
                        (item.category_name_json &&
                            item.category_name_json[getTranslateIndex]) ||
                        item.name)
              }}
            </div>
        </div>

        <!-- begin 菜品列表 -->
        <div class="menu-container" v-show="!pageLoading">
            <v-layout class="menu-layout">
                <v-layout ref="menuWrapper" :column="breakpoint.mdAndDown" v-if="!isTheme1">
                    <v-flex class="sidebar" shrink xs2 id="sidebar">
                        <div
                            class="sidebar-wrapper"
                            :class="{ 'fixed-bar': sidebarFixed, 'has-cookie': (pageFrom !== 'store') && showCookie }"
                        >
                            <v-layout class="sidebar-nav">
                                <div
                                    class="sidebar-nav__item side-list-hook"
                                    v-for="(item, index) in categoryList"
                                    :key="item.guid"
                                    :id="`sidebar-${index}`"
                                    :class="{ active: index === (getIsDacateShow ? activeCategoryIndex : activeCategory) }"
                                    v-show="item.commodites && item.commodites.length"
                                    @click="goAnchor($event, `#category-${index}`, index)"
                                >
                                    {{
                                        item.guid === 'recommended' ?
                                            (item.category_name_json[language] || item.name)
                                                :
                                            (
                                                (item.category_name_json &&
                                                    item.category_name_json[getTranslateIndex]) ||
                                                item.name)
                                    }}
                                </div>
                            </v-layout>
                        </div>
                    </v-flex>
                </v-layout>
                <v-flex class="menu-layout-content" ref="foodsWrapper" :xs9="!isTheme1">
                    <div
                        class="delivery food-list-hook"
                        v-for="(category, index) in deliveryMenu"
                        :key="category.guid"
                        :style="`padding-bottom: ${(getIsDacateShow && (activeCategoryIndex === index)) ? 50 : ''}px`"
                        v-show="category.commodites && category.commodites.length && (getIsDacateShow ? (activeCategoryIndex === index) : true )"
                        :id="`category-${index}`"
                    >
                        <div class="menu-heading" v-if="showCategoryName(category.commodites)">
                            <h4>
                                {{
                                    category.guid === 'recommended' ?
                                        (category.category_name_json[language] || category.name)
                                        :
                                        ((category.category_name_json &&
                                                category.category_name_json[getTranslateIndex]) ||
                                            category.name)
                                }}
                            </h4>
                        </div>
                        <div class="delivery-list">
                            <div
                                class="delivery-list__item"
                                align-center
                                v-for="item in category.commodites"
                                v-show="item.no !== '0' && showGoods(item) && !item.is_people"
                                :key="item.guid"
                            >
                                <v-layout>
                                    <v-flex
                                        v-if="item.cover && item.cover.url"
                                        shrink
                                        @click="goToDeliveryDetail(item)"
                                    >
                                        <div
                                            class="cover"
                                            :src="item.cover.url"
                                            :style="`background-image: url(${item.cover.url})`"
                                        ></div>
                                    </v-flex>
                                    <v-flex
                                        class="delivery-info"
                                        fill-height
                                    >
                                        <v-layout column fill-height justify-space-between>
                                            <div class="delivery-title">
                                                {{item.no}}.
                                                {{
                                                    (item.commodity_name_json &&
                                                        item.commodity_name_json[getTranslateIndex]) ||
                                                    item.name
                                                }}
                                            </div>
                                            <div class="theme1-price" v-if="isTheme1">
                                            </div>
                                            <v-layout
                                                :class="{'price-operate': true, 'theme1-price': true, 'show-padding': item.cover && item.cover.url}"
                                                center v-if="isTheme1"
                                                justify-space-between
                                            >
                                                <v-flex class="delivery-price" shrink>
                                                    €{{ item.price | fixed(2, true) }}
                                                </v-flex>
                                                <v-flex
                                                    :class="{ 'delivery-operate': true, right: !item.num }"
                                                    shrink
                                                    v-if="pageFrom === 'store' || storeInfo.orderScanner == 1
                    "
                                                >
                                                    <i class="iconfont icon-yichu icon" v-if="getGoodsNums(item.guid)" @click.stop.prevent="handleMinusFromCart(item.guid)"></i>
                                                    <div v-if="getGoodsNums(item.guid)">
                                                        <span class="show-num">{{ getGoodsNums(item.guid) }}</span>
                                                    </div>

                                                    <i class="icon iconfont icon-plus icon" v-if="item.garnish.length != 0" @click.stop.prevent="goToFoodDetail(item)"></i>
                                                    <i class="icon iconfont icon-plus icon" v-else @click.stop.prevent="handleAddToCart(item, index, $event)"></i>
                                                </v-flex>
                                            </v-layout>
                                            <div class="allergen-list">
                                                <div
                                                    class="item"
                                                    v-for="it in item.allergen"
                                                    :key="it.guid"
                                                >
                                                    <img
                                                        style="width:20px;height: 20px;"
                                                        :src="it.image"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                            <div class="delivery-content">
                                                {{
                                                    (item.description_json &&
                                                        item.description_json[getTranslateIndex]) ||
                                                    item.description
                                                }}
                                            </div>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout
                                    :class="{'price-operate': true,'show-padding': item.cover && item.cover.url}"
                                    center v-if="!isTheme1"
                                    justify-space-between
                                >
                                    <v-flex class="delivery-price" shrink>
                                        €{{ item.price | fixed(2, true) }}
                                    </v-flex>
                                    <v-flex
                                        :class="{ 'delivery-operate': true, right: !item.num }"
                                        shrink
                                        v-if="pageFrom === 'store' || storeInfo.orderScanner == 1
                    "
                                    >
                                        <i class="iconfont icon-yichu icon" v-if="getGoodsNums(item.guid)"
                                           @click.prevent="handleMinusFromCart(item.guid)"></i>
                                        <div v-if="getGoodsNums(item.guid)">
                                            <span class="show-num">{{ getGoodsNums(item.guid) }}</span>
                                        </div>

                                        <i class="icon iconfont icon-plus icon" v-if="item.garnish.length != 0" @click.prevent="goToFoodDetail(item)"></i>
                                        <i class="icon iconfont icon-plus icon" v-else @click.prevent="handleAddToCart(item, index, $event)"></i>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </div>
        <!-- end 菜品列表 -->

        <!-- begin 底部菜单 -->
        <div
            class="bottom-btn-container"
        >
            <ul class="language-ul" v-show="languageModalVisible">
                <li v-for="(item, index) in languageList" :key="'lan_' + index"
                    v-show="item.enable"
                    @click="handleChangeLanguage(languageListVal[item.val - 1])">{{ languageListText[item.val - 1] }}</li>
            </ul>
            <div class="left-container">
                <img class="language-icon" v-show="languageList && languageList.length>1"
                     @click="openlanguageModal" src="./../../../assets/language.png" alt="" />
                <div class="icon-con" :style="`visibility: ${storeInfo.orderScanner == 1?'visible': 'hidden'}`">
                    <div class="icon">
                        <v-icon dark size="20">list</v-icon>
                    </div>
                    <!-- 我的菜单 -->
                    <div @click="goToOrdered">
                        {{ $t("delivery.mymenu") }}({{ myOrder.items.length }})
                    </div>
                </div>
            </div>
            <div class="right-container" v-show="storeInfo.orderScanner == 1">
                <div class="line" v-if="isTheme1"></div>
                <div class="num" v-if="!isTheme1">({{ cartNums }})</div>
                <div class="nums" v-else>{{ cartNums }}</div>
                <!-- 查看 选好了 -->
                <div @click="onProceedToCheckout" class="detail-btn">
                    <div class="table-number">{{$t("delivery.number_table", {number: this.$route.query.tableNum})}}</div>
                    {{ $t("delivery.checkedMenu") }}
                </div>
            </div>
        </div>
        <!-- end 底部菜单 -->

        <!-- bengin 动效小球 -->
        <div class="ball-container">
            <div v-for="(ball, index) in balls" :key="index">
                <transition
                    name="cast-ball"
                    @before-enter="ballBeforeEnter"
                    @enter="ballEnter"
                    @after-enter="ballAfterEnter"
                >
                    <div class="horiz-ball" v-show="ball.show">
                        <div class="ball"></div>
                    </div>
                </transition>
            </div>
        </div>
        <!-- end 动效小球 -->
        <v-dialog v-model="declarationVisible" :persistent="true" max-width="500px">
            <v-card>
                <div
                    class="check-attributes-container-layout"
                >
                    <div class="declaration-title" style="text-align: center;font-size: 16px;font-weight: 600;">{{ declarationData && declarationData.title }}</div>
                    <div class="declaration-content" style="padding: 20px 0 0 0;max-height: 300px;overflow-y: auto;" v-html="declarationData && declarationData.content"></div>

                    <button
                        class="button attribute-button"
                        @click="closeDeclarationVisible"
                    >
                        {{ $t("delivery_detail.confirm") }}
                    </button>
                </div>
            </v-card>
        </v-dialog>
        <!-- begin 选择属性 -->
        <v-dialog v-model="isShowAttributes" max-width="500px">
            <v-card color="#fff">
                <div
                    class="check-attributes-container-layout"
                    v-if="attributes && attributes.length != 0"
                >
                    <div class="attributes-title">
                        <div>{{ $t("delivery.attribute") }}</div>
                    </div>
                    <div class="attributes-subtitle">
                        <div>{{ $t("delivery.attribute_tip") }}</div>
                    </div>
                    <div v-for="(cate, cateIndex) in attributes" :key="cate.guid">
                        <div class="title">{{ cate.attr_cate_name }}（{{$t(cate.type === 0 ? "unClass.add389" : 'unClass.add392', {num: cate.min_limit})}}）</div>
                        <div class="attributes-content">
                            <div
                                v-for="(item, index) in (cate.attributes || [])"
                                :key="index"
                                :class="{ item: true, active: item.check }"
                                @click="checkAttr(item, cateIndex, index)"
                            >
                                {{ item.name }}{{ Number(item.price) ? ` €${item.price}` : `` }}
                            </div>
                        </div>
                    </div>
                    <button
                        class="button attribute-button"
                        @click="handleAddToCartAttributes($event)"
                    >
                        {{ $t("delivery_detail.addToCart") }}
                    </button>
                </div>
            </v-card>
        </v-dialog>
        <!-- end 选择属性 -->
    </div>
</template>

<script>
import {mapState, mapGetters, mapMutations, mapActions} from "vuex";
import OrderMode from './order-mode';
import loading from './../../../components/common/loading';
import $ from "jquery";
import Qrcode from "@/api/qrcode";
import {fixed} from "../../../utils";

export default {
    data() {
        return {
            swiperOptions: {
                loop: true,
                speed: 300,
                autoHeight: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                }
            },
            languageModalVisible: false, //是否显示语言弹出框
            languageListZh: ['西班牙语', '意大利语', '葡萄牙语', '英语', '法语', '德语', '中文'],
            languageListText: ['Spanish', 'Italiano', 'Português', 'English', 'Français', 'Deutsch', '简体中文'],
            key: 1,
            offsetTop: 0,
            orderOffsetTop: 0,
            sidebarFixed: false,
            orderFixed: false,
            checked_guid: "",
            pageLoading: true,
            isNotOpenError: false,
            total: 0,
            discount: 0,
            discountAmount: 0,
            actuallyPaidAmount: 0,
            bannerList: [],
            activeDeliveryMenu: {
                commodites: []
            },
            balls: [
                {show: false},
                {show: false},
                {show: false},
                {show: false},
                {show: false},
                {show: false},
                {show: false},
                {show: false},
                {show: false},
                {show: false},
                {show: false}
            ],
            castBalls: [],
            listHeight: [],
            sideHeight: [],
            scrollY: 0, // 右侧的y值

            isShowAttributes: false,
            attributes: [],
            type: 1, //1 只开启了点餐， 2 只开启了自助， 3 开启了点餐和自助
            searchKeywords: '',
            listScrollTop: 0,
            stopScrollLeftMenu: false,
            hidePage: true,
            declarationVisible: false
        };
    },

    components: {
        OrderMode,
        loading
    },

    async created() {
        let isSecond = sessionStorage.getItem('isSecond'); //标识是否首次进入页面 第二次后不需要显示loading动画
        if(!isSecond){
            sessionStorage.setItem('isSecond', 1);
        }
        if (this.$route.query.tableGuid) {
            this.setTableGuid(this.$route.query.tableGuid);
        }
        if (this.$route.query.tableNum) {
            this.setTableNum(this.$route.query.tableNum);
        }
        if (this.$route.query.storeId) {
            this.setStoreId(this.$route.query.storeId);
            this.pageLoading = !isSecond;
            await this.getMyOrder();
            this.getStoreInfo((data) => {
                if (!this.isBuffet) {
                    if (data.isOpenBuffet && data.storeConf && data.storeConf.switchOrder) {
                        this.changeBuffet(null);
                    } else if (!data.isOpenBuffet && (data.storeConf && data.storeConf.switchOrder)) {
                        this.changeBuffet(1);
                    } else if (data.isOpenBuffet && !(data.storeConf && data.storeConf.switchOrder)) {
                        this.changeBuffet(2);
                    }
                }
                if (this.isBuffet) {
                    this.getData();
                    this.getBuffetRound();
                }else{
                    this.pageLoading = false;
                }
            });
        }
        this.reductionScroll();
    },

    sockets: {
        // 通信的name
        //这里是监听connect事件
        connect: function () {
            this.id = this.$socket.id;
            console.log("socket connected");
        }
    },

    mounted() {
        this.listScrollTop = sessionStorage.getItem('listScrollTop');

        window.addEventListener("scroll", this.handleScroll);
        this.getOffset();
        this.getBannerList();

        // 监听message事件，方法是后台定义和提供的
        this.sockets.subscribe(`message_${this.tableGuid}`, data => {
            if (!data) {
                this.resetCart([]);
            } else {
                let payload = JSON.parse(data).result.items.map(item => {
                    return {
                        ...item,
                        num: item.quantity,
                        is_threshold: item.is_threshold ? 1 : 0,
                        guid: item.commodityGuid,
                        attributes: item.attributes,
                        garnish: item.garnish
                    };
                });
                this.resetCart(payload);
            }
        });

        this.activeDeliveryMenu = this.deliveryMenu[this.activeCategory];
    },

    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
        this.sockets.unsubscribe(`message_${this.tableGuid}`);
    },
    computed: {
        ...mapState([
            "deliveryMenu",
            "showCookie",
            "storeInfo",
            "carts",
            "tableGuid",
            "myOrder",
            "pageFrom",
            "activeCategoryIndex",
            "activeCategory",
            "isBuffet",
            "isTheme1",
            "buffetRoundSetting",
            "languageList",
            "languageListVal",
            "language"
        ]),
        ...mapGetters(["categoryList", "cart", "getTranslateIndex", "declarationData"]),
        getIsDacateShow(){
            return !(this.storeInfo.storeConf && this.storeInfo.storeConf.is_dacate_show);
        },
        //获取商品在购物车数量
        getGoodsNums() {
            return (guid) => {
                let num = 0;
                (this.carts || []).map(item => {
                    if(item.guid === guid) num += item.num
                })
                return num;
            }
        },
        options() {
            return {
                duration: 10,
                offset: this.showCookie ? 70 : 0,
                easing: "easeInOutCubic"
            };
        },
        breakpoint() {
            return this.$vuetify.breakpoint;
        },
        cartNums() {
            return this.cart.items.reduce((accumulator, currentValue) => {
                return accumulator + currentValue.num;
            }, 0);
        },
        activeCategory() {
            if(this.getIsDacateShow) return null;
            let index = 0;
            if (this.scrollY == 0) {
                index = 0;
            } else {
                let foodList = this.$refs.foodsWrapper && this.$refs.foodsWrapper.querySelectorAll(
                    ".food-list-hook"
                );
                if(!foodList || !foodList.length) return 0;
                for (let i = 0, l = foodList.length; i < l; i++) {
                    let rect = foodList[i].getBoundingClientRect();
                    if(rect.y <= 80 && (Math.abs(rect.y) + 80) < rect.height){
                        this.scrollSidebar(i);
                        return i;
                    }
                }
            }
            return index;
        }
    },
    methods: {
        ...mapMutations([
            "addToCart",
            "resetCart",
            "removeFromCart",
            "minusFromCart",
            "setStoreId",
            "setTableGuid",
            "setTableNum",
            "setActiveCategoryIndex",
            "setDelivery",
            "changeBuffet",
            "setLanguage"
        ]),
        ...mapActions([
            "getDeliveries",
            "getStoreInfo",
            "getBuffetRound",
            "updateQrcodeCart",
            "getQrcodeCart",
            "getMyOrder"
        ]),

        getData() {
            this.initData();
            this.getQrcodeCart();
        },
        async getBannerList() {
            try {
                const res = await Qrcode.getDeliveyBanner({
                    type: 0
                });

                if (!res.data.isError) {
                    this.bannerList = res.data.data || [];
                }
            } catch (e) {
                console.log(e);
            }
        },

        closeDeclarationVisible(){
            this.declarationVisible = false;
            sessionStorage.setItem('showDeclarationVisible', 1)
        },

        selectMode(buffet) {
            this.changeBuffet(buffet ? 2 : 1);
            if(buffet){
                this.getBuffetRound();
            }
            this.getData();
        },

        showGoods(item){
            if(!this.searchKeywords) return true;
            let noFlag = item && item.no.includes(this.searchKeywords);
            let nameFlag = item && item.name.includes(this.searchKeywords);
            return nameFlag || noFlag;
        },

        showCategoryName(list=[]){
            return list.find(item=>{
                let noFlag = item && item.no.includes(this.searchKeywords);
                let nameFlag = item && item.name.includes(this.searchKeywords);
                return nameFlag || noFlag;
            })
        },

        /**
         * 切换分类
         */
        goAnchor(e, selector, index, flag) {
            e && e.preventDefault();

            this.setActiveCategoryIndex(index);

            if(this.getIsDacateShow){
                window.scrollTo(0, 0);
            }
            if(this.getIsDacateShow) return false;

            this.activeDeliveryMenu = this.deliveryMenu[this.activeCategory];

            let foodList = this.$refs.foodsWrapper && this.$refs.foodsWrapper.querySelectorAll(
                ".food-list-hook"
            );
            foodList[index].scrollIntoView();
            if(flag && document.getElementById(`sidebar-${index}`)){
                setTimeout(()=>{
                    document.getElementById(`sidebar-${index}`).click();
                })
            }
            // this.$vuetify.goTo(selector, this.options);
            // this.goTop();

            this.scrollSidebar(index);
        },

        scrollSidebar(checkIndex) {
            if(this.stopScrollLeftMenu) return ;
            let item = document.getElementById(`sidebar-${checkIndex}`);
            item && item.scrollIntoView({inline: "start"});
        },

        /**
         * 回到顶部
         */
        goTop() {
            let timer = null;
            timer = setInterval(() => {
                let topDistance =
                    document.documentElement.scrollTop || document.body.scrollTop;
                let moveDistance = Math.floor(-topDistance / 5);
                document.documentElement.scrollTop = document.body.scrollTop =
                    topDistance + moveDistance;
                if (topDistance === 0) {
                    clearInterval(timer);
                }
            }, 30);
        },

        // 如果记录了滚动的位置，则还原到该位置
        reductionScroll() {
            if(this.listScrollTop && Number(this.listScrollTop) > 0){
                this.stopScrollLeftMenu = true;
            }
            (document.documentElement || document.body).scrollTop = Number(this.listScrollTop || 0);
            setTimeout(()=>{
                this.handleScroll();
                this.stopScrollLeftMenu = false;
                this.hidePage = false;
            }, 200);
        },

        handleScroll() {
            // 得到页面滚动的距离
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;

            sessionStorage.setItem('listScrollTop', scrollTop);

            let offsetTop = this.offsetTop;
            let orderOffsetTop = this.orderOffsetTop - 90 - 10;

            if (this.showCookie) {
                offsetTop -= this.$vuetify.breakpoint.xs ? 80 : 60;
                orderOffsetTop -= this.$vuetify.breakpoint.xs ? 80 : 60;
            }

            let sidebarFixed = scrollTop > offsetTop;
            let orderFixed = scrollTop > orderOffsetTop;

            this.sidebarFixed = sidebarFixed;
            this.orderFixed = orderFixed;
            this.scrollY = scrollTop < 150 ? scrollTop : scrollTop - 150;
        },

        /**
         * 去结算
         */
        onProceedToCheckout() {
            this.$router.push({
                name: "checkout"
            });
        },
        handleResize() {
            let orderWidth = "auto";
            let sidebarWidth = "auto";

            if (!this.breakpoint.mdAndDown) {
                orderWidth = $("#order").width();
                sidebarWidth = $("#sidebar").width();
            }

            $(".order").width(orderWidth);
            $(".sidebar-wrapper").width(sidebarWidth);

            let slide_height = $(window).height() - ((this.pageFrom !== 'store') && this.showCookie ? 120 : 50);
            let goodlistHeight = slide_height - (this.pageFrom === 'store' ? 62 : 0);
            $(".fixed-bar").css("max-height", slide_height + "px");
            $(".fixed-order").css("max-height", slide_height + "px");
            $(".menu-layout-content").css("max-height", goodlistHeight + "px");
        },

        /**
         * 添加至本地购物车
         * @param {*} guid 商品id
         * @param {*} ev event事件对象
         */
        async handleAddToCart(item, index, ev) {
            if (this.isBuffet === 2 && (!this.myOrder || !this.myOrder.guid)) {
                await this.getMyOrder();
                if (this.isBuffet === 2 && (!this.myOrder || !this.myOrder.guid)) {
                    alert(this.$t("checkout.open-order"));
                    return;
                }
            }
            if(!this.$analysisRound(this.buffetRoundSetting, [...(this.carts || []), item], this.myOrder, this.isBuffet)) return ;
            this.delivery = item;
            let num = 0;
            (this.carts || []).map(it => {
                if(it.guid === item.guid) {
                    num += it.num;
                    item.attributes = it.attributes;
                }
            })

            if (!num && item.attributes_cate && item.attributes_cate.length != 0) {
                this.attributes = JSON.parse(JSON.stringify(item.attributes_cate || []));
                // this.attributes = item.attributes_cate || [];
                this.isShowAttributes = true;
            } else {
                const payload = {
                    ...item,
                    guid: item.guid,
                    num: 1
                };

                this.checked_guid = item.guid;

                setTimeout(() => {
                    this.checked_guid = "";
                }, 3000);

                this.addToCart(payload);
                this.castBall(ev.target);

                this.updateQrcodeCart();
            }
        },

        handleAddToCartAttributes(ev) {
            let selected = [];
            if(this.attributes && this.attributes.length){
                let flag = true;
                this.attributes.forEach(cate=>{
                    if(cate.attributes){
                        cate.attributes.forEach(attr=>{
                            if(attr.check){
                                selected.push(attr.guid);
                            }
                        })
                    }
                })
                this.attributes.forEach(item=>{
                    if(!this.$allowAddAttr(this.attributes, selected, null, item)) flag = false;
                });
                if(!flag) return ;
            }

            let payload = {
                ...this.delivery,
                num: 1,
                guid: this.delivery.guid,
                attributes: selected
            };
            this.addToCart(payload);

            this.isShowAttributes = false;
            this.castBall(ev.target);

            this.updateQrcodeCart();
        },

        /**
         * 选中可用小球
         */
        castBall(el) {
            // 找到第一个show为false（可用）的小球，然后就跳出循环
            this.balls.some(ball => {
                if (!ball.show) {
                    ball.show = true;
                    ball.el = el;
                    this.castBalls.push(ball);
                    return true;
                }
            });
        },

        ballBeforeEnter(el) {
            let len = this.balls.length;
            for (let i = 0; i < len; i++) {
                let ball = this.balls[i];
                if (ball.show) {
                    let rect = ball.el.getBoundingClientRect();

                    const winWidth = this.$vuetify.breakpoint.width;
                    let x = rect.left - winWidth / 2;
                    let y = rect.top - window.innerHeight + 40;
                    el.style.webkitTransform = `translate3d(${x}px,0,0)`;
                    el.style.transform = `translate3d(${x}px,0,0)`;
                    let child = el.children[0];
                    child.style.transform = `translate3d(0,${y}px,0)`;
                    child.style.webkitTransform = `translate3d(0,${y}px,0)`;
                }
            }
        },

        ballEnter(el, done) {
            el.timer = setTimeout(() => {
                el.style.webkitTransform = `translate3d(0,0,0)`;
                el.style.transform = `translate3d(0,0,0)`;
                let child = el.children[0];
                child.style.transform = `translate3d(0,0,0)`;
                child.style.webkitTransform = `translate3d(0,0,0)`;
                el.addEventListener("transitionEnd", done);
                el.addEventListener("webkitTransitionEnd", done);
            }, 30);
        },

        ballAfterEnter(el) {
            let ball = this.castBalls.shift();
            if (ball) {
                ball.show = false;
                el.style.display = "none";
                clearTimeout(el.timer);
            }
        },

        handleRemoveFromCart(guid) {
            this.removeFromCart(guid);
        },
        handleMinusFromCart(guid) {
            this.minusFromCart({
                num: 1,
                guid
            });

            this.updateQrcodeCart();
        },

        /**
         * 去商品套餐详情
         */
        goToFoodDetail(item, showImage) {
            if (item.garnish.length == 0) {
                return;
            }
            this.$router.push({
                name: "good/detail",
                params: {id: item.guid},
                query: {
                    showImage: showImage
                }
            });
        },

        /**
         * 去商品详情
         */
        goToDeliveryDetail(item) {
            if (item.garnish.length != 0) {
                this.goToFoodDetail(item, 1);
            } else {
                this.$router.push({
                    name: "delivery/detail",
                    params: {id: item.guid}
                });
            }
        },

        async initData() {
            this.pageLoading = this.deliveryMenu.length === 0;
            await this.getDeliveries(this.isBuffet === 2 ? 1 : 0);
            this.pageLoading = false;

            this.$nextTick(() => {
                this._calculateHeight();
                this._calculateSideHeight();
            });
        },

        _calculateHeight() {
            //  获取 li 通过food-list-hook
            let foodList = this.$refs.foodsWrapper && this.$refs.foodsWrapper.querySelectorAll(
                ".food-list-hook"
            ) || [];
            let height = 0; // 初始化高度
            this.listHeight.push(height); //  把第一个高度存入数组
            //通过循环foodList下的dom结构，将每一个li的高度依次送入数组
            for (let i = 0, l = foodList.length; i < l; i++) {
                let item = foodList[i]; //每一个item都是刚才获取的food的每一个dom
                height += item.clientHeight; //获取每一个foods内部块的高度
                this.listHeight.push(height); // 将获取的值存放到数组里
            }
        },

        _calculateSideHeight() {
            //  获取 li 通过side-list-hook
            let foodList = this.$refs.menuWrapper && this.$refs.menuWrapper.querySelectorAll(".side-list-hook");
            let height = 0; // 初始化高度
            if(!foodList) return ;

            this.sideHeight.push(height); //  把第一个高度存入数组
            //通过循环foodList下的dom结构，将每一个li的高度依次送入数组
            for (let i = 0, l = foodList.length; i < l; i++) {
                let item = foodList[i]; //每一个item都是刚才获取的food的每一个dom
                height += item.clientHeight; //获取每一个foods内部块的高度
                this.sideHeight.push(height); // 将获取的值存放到数组里
            }
        },

        goToOrdered() {
            this.$router.push({
                name: "ordered",
                query: {
                    redirect: "delivery" // 我的菜单返回菜品列表页
                }
            });
        },

        getOffset() {
            this.$nextTick(function () {
                this.handleResize();
                let header = document.getElementById("sidebar");
                this.offsetTop = header && header.offsetTop;
            });
        },

        /**
         * 选择属性标签
         */
        checkAttr(item, cateIndex, index) {
            let attributes = JSON.parse(JSON.stringify(this.attributes));

            if(!attributes[cateIndex].attributes[index].check){
                let selected = [];
                attributes.map(cate=>{
                    if(cate.attributes){
                        cate.attributes.forEach((att_item, index) => {
                            if (att_item.check) {
                                selected.push(att_item.guid)
                            }
                        })
                    }
                });
                if(!this.$allowAddAttr(attributes, selected, item.guid)) return ;
            }

            attributes.map(cate=>{
                if(cate.attributes){
                    cate.attributes.forEach((att_item, index) => {
                        if (att_item.guid === item.guid) {
                            att_item.check = !att_item.check;
                        }
                    })
                }
            });

            let cart_attributes = [];
            attributes.map(cate=>{
                if(cate.attributes){
                    cate.attributes.forEach((att_item, index) => {
                        if (att_item.check) {
                            cart_attributes.push(att_item.guid)
                        }
                    })
                }
            });

            let carts = this.carts.slice(0);

            this.resetCart(carts);

            this.setDelivery({
                ...this.delivery,
                attributes,

            });

            this.attributes = JSON.parse(JSON.stringify(attributes));
        },
        openlanguageModal(){
            this.languageModalVisible = !this.languageModalVisible
        },
        handleChangeLanguage(language) {
            this.setLanguage(language);
            this.$i18n.locale = language;
            this.languageModalVisible = false;
            localStorage.setItem('language', language);
        },
        // 点击轮播图跳转
        handleBannerClick(item) {
            if (item.link_url) {
                window.open(item.link_url, "_blank");
            } else if (item.link_type == 0 && item.link_guid) {
                let menuIndex = null;
                this.categoryList.map((_item, index) => {
                    if (_item.categoryGuid === item.link_guid) {
                        menuIndex = index;
                    }
                });
                if(menuIndex || menuIndex === 0) this.goAnchor("", `#category-${menuIndex}`, menuIndex, true);
            } else if (item.link_type == 1 && item.link_guid) {
                this.goToDetail(item.link_guid, "detail");
            }
        },
        goToDetail(guid) {
            this.$router.push({
                name: "delivery/detail",
                params: {id: guid}
            });
        },
    },
    watch: {
        declarationData(){
            if(this.declarationData && this.declarationData.title && this.declarationData.content){
                if(!sessionStorage.getItem('showDeclarationVisible')){
                    this.declarationVisible = true;
                }
            }
        },
        "breakpoint.mdAndDown"() {
            this.getOffset();
            this.handleScroll();
        },
        offsetTop() {
            this.getOffset();
            this.handleScroll();
        },
        showCookie() {
            this.getOffset();
            this.handleScroll();
        },
        pageLoading() {
            this.getOffset();
            this.handleScroll();
        },
        deliveryMenu() {
            // 默认展示第一个分类的菜品
            this.activeDeliveryMenu = this.deliveryMenu[this.activeCategory];
        },
        "cart.items"(items) {
            // 通过对比购物车和菜单列表 在菜单列表加上数量num字段
            if (this.activeDeliveryMenu && this.activeDeliveryMenu.commodites) {
                let menuList = this.activeDeliveryMenu.commodites || [];

                this.activeDeliveryMenu.commodites.map((menu_item, menu_index) => {
                    menuList[menu_index].num = 0;

                    items.map(cart_item => {
                        if (menu_item.guid == cart_item.guid) {
                            menuList[menu_index].num = cart_item.num;
                        }
                    });
                });

                this.activeDeliveryMenu.commodites = menuList || [];
            }
        },
        activeDeliveryMenu() {
            // 通过对比购物车和菜单列表 在菜单列表加上数量num字段
            if (this.activeDeliveryMenu && this.activeDeliveryMenu.commodites) {
                let menuList = this.activeDeliveryMenu.commodites || [];

                this.activeDeliveryMenu.commodites.map((menu_item, menu_index) => {
                    menuList[menu_index].num = 0;

                    this.cart.items.map(cart_item => {
                        if (menu_item.guid == cart_item.guid) {
                            menuList[menu_index].num = cart_item.num;
                        }
                    });
                });

                this.activeDeliveryMenu.commodites = menuList || [];
            }
        }
    },
    filters: {
        fixed
    }
};
</script>

<style scoped lang="sass" src="./delivery-list.sass"></style>
